const lastWhitespaceRegex = /\s*$/g;
const whitespaceRegex = /\s+/g;
const multiDashRegex = /-+/g;

export function isEllipseChar(str: string, amt: number): string {
  return !!str?.substr(amt, 1) ? str : "";
}

export function ellipseChar(str: string, amt: number): string {
  return str?.substr(0, amt) + (!!str?.substr(amt, 1) ? " ..." : "");
}

export function isEllipseWord(str: string, amt: number): string {
  return str?.split(" ").length > amt ? str : "";
}

export function ellipseWord(str: string, amt: number, maxChar: number = 20): string {
  const result = str?.split(" ").slice(0, amt).join(" ") + (str?.split(" ").length > amt ? " ..." : "");
  // FIXME: ... adds up to ellipseChar ...
  return ellipseChar(result, maxChar);
}

export function chunkSubstr(str: string, size: number) {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
}

export const toFixed = (value: number, digit: number) => {
  const zeros = [...new Array(digit)].map((x) => "0").join("");
  return `${zeros}${value}`.slice(-digit);
};

export const sanitize = (text: string) => {
  if (!text) return "";
  text = text.replace(lastWhitespaceRegex, "");
  text = text.replace(whitespaceRegex, "-");
  text = text.replace(multiDashRegex, "-");
  return text;
};

export const toHtml = (value: string) => value?.replace(/\n/g, "<br />");
